const base = {
    get_currency_codes:"/get_currency_codes", 
    get_price:"/get_price",
    verify_email:"/verify_email",
    check_email_verification_code:"/check_email_verification_code",
    puchase_form:"/puchase_form",
    capture_by_paypal_user:"/capture_by_paypal_user",
    capture_by_wechat_user:"/capture_by_wechat_user",
    paypal_payment_finished:"/paypal_payment_finished",
    get_token:"/get_token",
    get_history:"/get_history"
}

export default base;